import React from "react";
import { Link } from "react-router-dom";
import "../styles/TwentyTwentysixContent.css";

export default function ProgramsPage() {
  return (
    <div className="twentytwentysix-content">
      <div className="twentytwentysix-content__container">
        <p className="twentytwentysix-content__eyebrow">The Mamahood</p>
        <h1 className="twentytwentysix-content__title">Signature Programs</h1>
        <p className="twentytwentysix-content__copy">
          Our programs bring mamas together for growth, movement, and support. Explore what we offer and find your fit.
        </p>
        <div className="twentytwentysix-content__cta-row">
          <Link to="/twentytwentysix" className="twentytwentysix-content__pill">Back to Home</Link>
        </div>

        <section className="twentytwentysix-content__section">
          <h2 className="twentytwentysix-content__subtitle">Programs</h2>
          <div className="twentytwentysix-content__card-grid">
            <div className="twentytwentysix-content__card">
              <h4>Moving in Motion</h4>
              <p>A social impact series centered around the Bay Area community. Movement, wellness, and connection.</p>
            </div>
            <div className="twentytwentysix-content__card">
              <h4>Mamahood Experiences</h4>
              <p>Explore our programs to get and give support with other mamas. Workshops, retreats, and circles.</p>
            </div>
            <div className="twentytwentysix-content__card">
              <h4>Yoga For Moms</h4>
              <p>Yoga series in Walnut Creek and beyond. Running through March and April 2026 — check for dates.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
